export const roundWithPrecision = (value: number, precision = 10) => {
    const factor = 10 ** precision;
    return Math.round(value * factor) / factor;
};
